import React from 'react'
import type { IconType } from 'react-icons'
import { FaArrowRight } from 'react-icons/fa'
import { FiBox } from 'react-icons/fi'
import Lottie from 'lottie-react'

import loadAnim from './Animations/loading.json'

interface StatItem {
  label: string
  value: number
  icon: JSX.Element
}

interface OrderTotalCardProps {
  totalOrders: number
  stats: StatItem[]
  isTotalCardLoading?: boolean
}

const bgMap: Record<string, string> = {
  Confirmed: 'bg-P-300 ',
  Cancelled: 'bg-P-200',
  Dispatched: 'bg-P-100',
}

const OrderTotalCard: React.FC<OrderTotalCardProps> = ({
  totalOrders,
  stats,
  isTotalCardLoading,
}) => {
  return (
    <div className='flex flex-col sm:flex-row items-center gap-4 w-full'>
      {/* Total Orders Box */}
      <div className='bg-P-500 text-white rounded-lg px-4 sm:px-6 py-4 w-full sm:w-48 flex flex-col items-center justify-center'>
        <FiBox className='text-2xl mb-1 text-center' />
        <p className='text-sm font-semibold'>Total Orders</p>
        <p className='text-2xl font-bold text-center'>
          {totalOrders.toLocaleString()}
        </p>
      </div>

      {/* Arrow: hidden on mobile */}
      <div className='text-P-500 text-xl font-bold hidden sm:block'>
        <FaArrowRight />
      </div>

      {/* Stat Cards */}
      <div className='flex flex-col sm:flex-row gap-3 w-full'>
        {stats.map(({ label, value, icon }) => (
          <div
            key={label}
            className={`${
              bgMap[label] ?? 'bg-P-100'
            } rounded-lg shadow-sm px-4 sm:px-6 py-4 flex-1 flex flex-col items-start justify-center min-w-[100px]`}>
            <div className='text-xl mb-1'>{icon}</div>
            <p className='text-sm font-semibold text-gray-700'>{label}</p>
            {isTotalCardLoading ? (
              <Lottie
                animationData={loadAnim}
                loop
                style={{ width: 100, height: 50 }}
              />
            ) : (
              <p className='text-xl font-bold text-gray-900'>
                {value.toLocaleString()}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default OrderTotalCard
